// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #0f0f0f;
}

p {
  color: #0f0f0f;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Poppins", sans-serif;
}

code {
  font-family: "Poppins", sans-serif;
}

html {
  font-size: 62.5%;
}

a {
  text-decoration: none;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* font-size */
.fs-10 {
  font-size: 1rem !important;
}

.fs-12 {
  font-size: 1.2rem !important;
}

.fs-14 {
  font-size: 1.4rem !important;
}

.fs-16 {
  font-size: 1.6rem !important;
}

.fs-20 {
  font-size: 2rem !important;
}

/* Font-Weight */
.fw-400 {
  font-weight: 400 !important;
}

.fw-500 {
  font-weight: 500 !important;
}

.fw-600 {
  font-weight: 600 !important;
}

.fw-700 {
  font-weight: 700 !important;
}

/* Width */
.w7 {
  width: 7%;
}

.w5 {
  width: 5%;
}

.w10 {
  width: 10%;
}

.w20 {
  width: 20% !important;
}

.w30 {
  width: 30% !important;
}

.w40 {
  width: 40% !important;
}

.w60 {
  width: 60% !important;
}

.w70 {
  width: 70% !important;
}

.w80 {
  width: 80% !important;
}

.w90 {
  width: 90% !important;
}

.w100 {
  width: 100% !important;
}

.pd {
  padding: 0px !important;
}

/* Css for Form Details */
.form_wrapper {
  border: solid black;
  border-radius: 0.5rem;
  padding: 2rem;
}
.spinner {
  width: 15px;
  height: 14px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.form_wrapper .form_label {
  position: absolute;
  margin-top: -34px;
  margin-left: 10px;
  color: black;
  background: white;
  border-radius: 0.1rem;
  padding: 2px 8px;
}

/* set background color for pages */
.bg_color {
  background-color: rgb(241, 241, 240);
  border-radius: 5px;
}

/* login logo image height and width */
.login_logo {
  height: auto;
  width: 14rem;
}

.login_box {
  min-width: 50vw;
  min-height: 45vh;
}

.log_form {
  display: flex;
  justify-content: space-between;
  height: 100%;
}

.textfield_background {
  background-color: rgb(241, 241, 240);
}

.sevenly-btn {
  line-height: 40px !important;
  border-radius: 40px !important;
  background: #22ccb2 !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  letter-spacing: 1px !important;
  text-transform: uppercase !important;
}

.sevenly-btn:hover {
  border: 0;
  background-color: #22ccb2;
}

.sevenly-cursor {
  color: #22ccb2;
}

/* applying radius for cards */
.border_radius {
  border-radius: 10px !important;
}

.bg_white {
  background-color: white;
}

/* set height of the bar graph */
.bar_graph {
  height: 24rem !important;
}

.barh {
  height: 14rem !important;
  margin-top: 5rem;
  width: 100% !important;
}

/* align the text into middle */
.align-middle {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.card-container {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
}

.equal-card {
  flex: 1 1;
  width: 100%;
}

/* Css for Datatables */

.MuiTableCell-head {
  white-space: nowrap !important;
}

.MuiInputBase-input {
  font-size: 14px !important;
}

/* gemba page card */
.card_hegiht {
  height: 9rem !important;
}

/* assembly card circular graph width */
.cir_width {
  width: 6rem !important;
  background-color: white;
}

/* custom graph heigh and width */
.custom_graph {
  height: 1.5rem !important;
  width: 100% !important;
  background-color: lightgray;
}

.line_height {
  line-height: 0.5rem !important;
}

.cir_height {
  width: 4.9rem !important;
}

.red {
  padding: 2rem;
  background-color: red !important;
}

.p-10rem {
  padding: 10rem !important;
}

.gray-border {
  border: 0.1rem solid rgb(199, 198, 198) !important;
  color: black !important;
  border-radius: 0.4rem !important;
  padding: 0.7rem !important;
}

.blue {
  background-color: #6d83e8 !important;
}

.blue-border {
  border: 0.2rem solid #6d83e8 !important;
}

.view-btn {
  font-size: 14px !important;
  font-weight: 600 !important;
  letter-spacing: 1px !important;
}

.red {
  background-color: #e23026 !important;
}

.red-border {
  border: 0.2rem solid #e23026 !important;
}

.yellow-btn {
  background-color: #fcbb15 !important;
}

.yellow-border {
  border: 0.2rem solid #fcbb15 !important;
}

.green-btn {
  background-color: #39bfa7 !important;
}

.green-border {
  border: 0.2rem solid #39bfa7 !important;
}

.purple {
  background-color: #7360ee !important;
}

.purple-border {
  border: 0.2rem solid #7360ee !important;
}

.MuiFormHelperText-root {
  font-size: 1.2rem !important;
  font-weight: 600 !important;
}

.MuiFormHelperText-root {
  color: #198754 !important;
  font-family: "ABBVoice-bold", "sans-serif" !important;
}

.MuiFormHelperText-root.Mui-error {
  color: #d32f2f !important;
  font-family: "ABBVoice-bold", "sans-serif" !important;
}

/* newly added */
.red-color {
  color: #e23026 !important;
}

.green-color {
  color: #3aaf57;
}

.parent-container-table {
  width: 150px !important;
  /* Ensure it overrides MUI styles */
  white-space: normal;
  /* Allow text to wrap inside the container */
}

.clamp-3-lines {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* Number of lines to display */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 150px !important;
}

.border-bottom {
  border-bottom: 1px solid gray;
}

.traveller_name {
  border-radius: 1px;
}

.cancel-button {
  padding: 8px 20px;
  border: 1px solid rgb(229, 27, 16) !important;
  border-radius: 8px;
  font-family: "Poppins", sans-serif !important;

  background-color: white !important;

  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1) !important;

  color: red !important;

  text-align: center !important;

  cursor: pointer !important;

  font-weight: 400 !important;
  font-size: 10px !important;
}

.submit-button {
  padding: 8px 20px;
  border: 1px solid #3dd2cc !important;
  font-family: "Poppins", sans-serif !important;
  border-radius: 8px !important;

  background-color: #3dd2cc !important;

  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1) !important;

  color: white !important;
  text-align: center !important;

  cursor: pointer !important;

  font-weight: 300 !important;
  font-size: 10px !important;
}

.view-style {
  font-family: "Poppins", sans-serif !important;
}

.capsule {
  font-weight: 600;
  padding: 6px 12px;
  /* Adjusted: 6px vertical, 12px horizontal */
  border-radius: 43px;
  font-size: 13px;
  text-align: center;
  width: max-content !important;
}

.published {
  background-color: #d4f8e8;

  color: #28a745;
}

.unpublished {
  background-color: #f8d7da;

  color: #dc3545;
}

.custom-input {
  color: rgb(8, 8, 8) !important;
  font-weight: 500 !important;
}

.icon-size {
  font-size: 20px !important;
}

.downLoadCSVIcon {
  color: #757575 !important;
  font-size: 18px !important;
}

.text-green {
  color: green;
}

.text-red {
  color: red;
}

.disabled-label {
  color: #999;
  /* Lighter text color for disabled state */
  cursor: not-allowed;
  /* Show a disabled cursor */
}

.failed-status {
  color: red;
  /* Red color for 'Booking Failed' text */
}

.Booking-cancel-label {
  font-size: 20px !important;
  font-weight: bold;
  color: #002fff;
  /* Default color for active label */
  cursor: pointer;
  /* Pointer cursor when active */
}

.csv-link {
  font-weight: bold !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;EAME,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA,uBAAuB;;AAEvB;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,uBAAuB;EACvB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,6CAA6C;EAC7C,kBAAkB;EAClB,6CAA6C;;EAE7C,kCAAkC;;EAElC,qDAAqD;;EAErD,qBAAqB;;EAErB,6BAA6B;;EAE7B,0BAA0B;;EAE1B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,6CAA6C;EAC7C,6BAA6B;;EAE7B,oCAAoC;;EAEpC,qDAAqD;;EAErD,uBAAuB;EACvB,6BAA6B;;EAE7B,0BAA0B;;EAE1B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;EAC5C,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;;EAEzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;;EAEzB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["body {\n  margin: 0;\n  font-family: \"Poppins\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #0f0f0f;\n}\n\np {\n  color: #0f0f0f;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Poppins\", sans-serif;\n}\n\ncode {\n  font-family: \"Poppins\", sans-serif;\n}\n\nhtml {\n  font-size: 62.5%;\n}\n\na {\n  text-decoration: none;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* font-size */\n.fs-10 {\n  font-size: 1rem !important;\n}\n\n.fs-12 {\n  font-size: 1.2rem !important;\n}\n\n.fs-14 {\n  font-size: 1.4rem !important;\n}\n\n.fs-16 {\n  font-size: 1.6rem !important;\n}\n\n.fs-20 {\n  font-size: 2rem !important;\n}\n\n/* Font-Weight */\n.fw-400 {\n  font-weight: 400 !important;\n}\n\n.fw-500 {\n  font-weight: 500 !important;\n}\n\n.fw-600 {\n  font-weight: 600 !important;\n}\n\n.fw-700 {\n  font-weight: 700 !important;\n}\n\n/* Width */\n.w7 {\n  width: 7%;\n}\n\n.w5 {\n  width: 5%;\n}\n\n.w10 {\n  width: 10%;\n}\n\n.w20 {\n  width: 20% !important;\n}\n\n.w30 {\n  width: 30% !important;\n}\n\n.w40 {\n  width: 40% !important;\n}\n\n.w60 {\n  width: 60% !important;\n}\n\n.w70 {\n  width: 70% !important;\n}\n\n.w80 {\n  width: 80% !important;\n}\n\n.w90 {\n  width: 90% !important;\n}\n\n.w100 {\n  width: 100% !important;\n}\n\n.pd {\n  padding: 0px !important;\n}\n\n/* Css for Form Details */\n.form_wrapper {\n  border: solid black;\n  border-radius: 0.5rem;\n  padding: 2rem;\n}\n.spinner {\n  width: 15px;\n  height: 14px;\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #3498db;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.form_wrapper .form_label {\n  position: absolute;\n  margin-top: -34px;\n  margin-left: 10px;\n  color: black;\n  background: white;\n  border-radius: 0.1rem;\n  padding: 2px 8px;\n}\n\n/* set background color for pages */\n.bg_color {\n  background-color: rgb(241, 241, 240);\n  border-radius: 5px;\n}\n\n/* login logo image height and width */\n.login_logo {\n  height: auto;\n  width: 14rem;\n}\n\n.login_box {\n  min-width: 50vw;\n  min-height: 45vh;\n}\n\n.log_form {\n  display: flex;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.textfield_background {\n  background-color: rgb(241, 241, 240);\n}\n\n.sevenly-btn {\n  line-height: 40px !important;\n  border-radius: 40px !important;\n  background: #22ccb2 !important;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  letter-spacing: 1px !important;\n  text-transform: uppercase !important;\n}\n\n.sevenly-btn:hover {\n  border: 0;\n  background-color: #22ccb2;\n}\n\n.sevenly-cursor {\n  color: #22ccb2;\n}\n\n/* applying radius for cards */\n.border_radius {\n  border-radius: 10px !important;\n}\n\n.bg_white {\n  background-color: white;\n}\n\n/* set height of the bar graph */\n.bar_graph {\n  height: 24rem !important;\n}\n\n.barh {\n  height: 14rem !important;\n  margin-top: 5rem;\n  width: 100% !important;\n}\n\n/* align the text into middle */\n.align-middle {\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.card-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  align-items: stretch;\n}\n\n.equal-card {\n  flex: 1;\n  width: 100%;\n}\n\n/* Css for Datatables */\n\n.MuiTableCell-head {\n  white-space: nowrap !important;\n}\n\n.MuiInputBase-input {\n  font-size: 14px !important;\n}\n\n/* gemba page card */\n.card_hegiht {\n  height: 9rem !important;\n}\n\n/* assembly card circular graph width */\n.cir_width {\n  width: 6rem !important;\n  background-color: white;\n}\n\n/* custom graph heigh and width */\n.custom_graph {\n  height: 1.5rem !important;\n  width: 100% !important;\n  background-color: lightgray;\n}\n\n.line_height {\n  line-height: 0.5rem !important;\n}\n\n.cir_height {\n  width: 4.9rem !important;\n}\n\n.red {\n  padding: 2rem;\n  background-color: red !important;\n}\n\n.p-10rem {\n  padding: 10rem !important;\n}\n\n.gray-border {\n  border: 0.1rem solid rgb(199, 198, 198) !important;\n  color: black !important;\n  border-radius: 0.4rem !important;\n  padding: 0.7rem !important;\n}\n\n.blue {\n  background-color: #6d83e8 !important;\n}\n\n.blue-border {\n  border: 0.2rem solid #6d83e8 !important;\n}\n\n.view-btn {\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  letter-spacing: 1px !important;\n}\n\n.red {\n  background-color: #e23026 !important;\n}\n\n.red-border {\n  border: 0.2rem solid #e23026 !important;\n}\n\n.yellow-btn {\n  background-color: #fcbb15 !important;\n}\n\n.yellow-border {\n  border: 0.2rem solid #fcbb15 !important;\n}\n\n.green-btn {\n  background-color: #39bfa7 !important;\n}\n\n.green-border {\n  border: 0.2rem solid #39bfa7 !important;\n}\n\n.purple {\n  background-color: #7360ee !important;\n}\n\n.purple-border {\n  border: 0.2rem solid #7360ee !important;\n}\n\n.MuiFormHelperText-root {\n  font-size: 1.2rem !important;\n  font-weight: 600 !important;\n}\n\n.MuiFormHelperText-root {\n  color: #198754 !important;\n  font-family: \"ABBVoice-bold\", \"sans-serif\" !important;\n}\n\n.MuiFormHelperText-root.Mui-error {\n  color: #d32f2f !important;\n  font-family: \"ABBVoice-bold\", \"sans-serif\" !important;\n}\n\n/* newly added */\n.red-color {\n  color: #e23026 !important;\n}\n\n.green-color {\n  color: #3aaf57;\n}\n\n.parent-container-table {\n  width: 150px !important;\n  /* Ensure it overrides MUI styles */\n  white-space: normal;\n  /* Allow text to wrap inside the container */\n}\n\n.clamp-3-lines {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  /* Number of lines to display */\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 150px !important;\n}\n\n.border-bottom {\n  border-bottom: 1px solid gray;\n}\n\n.traveller_name {\n  border-radius: 1px;\n}\n\n.cancel-button {\n  padding: 8px 20px;\n  border: 1px solid rgb(229, 27, 16) !important;\n  border-radius: 8px;\n  font-family: \"Poppins\", sans-serif !important;\n\n  background-color: white !important;\n\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1) !important;\n\n  color: red !important;\n\n  text-align: center !important;\n\n  cursor: pointer !important;\n\n  font-weight: 400 !important;\n  font-size: 10px !important;\n}\n\n.submit-button {\n  padding: 8px 20px;\n  border: 1px solid #3dd2cc !important;\n  font-family: \"Poppins\", sans-serif !important;\n  border-radius: 8px !important;\n\n  background-color: #3dd2cc !important;\n\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1) !important;\n\n  color: white !important;\n  text-align: center !important;\n\n  cursor: pointer !important;\n\n  font-weight: 300 !important;\n  font-size: 10px !important;\n}\n\n.view-style {\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.capsule {\n  font-weight: 600;\n  padding: 6px 12px;\n  /* Adjusted: 6px vertical, 12px horizontal */\n  border-radius: 43px;\n  font-size: 13px;\n  text-align: center;\n  width: max-content !important;\n}\n\n.published {\n  background-color: #d4f8e8;\n\n  color: #28a745;\n}\n\n.unpublished {\n  background-color: #f8d7da;\n\n  color: #dc3545;\n}\n\n.custom-input {\n  color: rgb(8, 8, 8) !important;\n  font-weight: 500 !important;\n}\n\n.icon-size {\n  font-size: 20px !important;\n}\n\n.downLoadCSVIcon {\n  color: #757575 !important;\n  font-size: 18px !important;\n}\n\n.text-green {\n  color: green;\n}\n\n.text-red {\n  color: red;\n}\n\n.disabled-label {\n  color: #999;\n  /* Lighter text color for disabled state */\n  cursor: not-allowed;\n  /* Show a disabled cursor */\n}\n\n.failed-status {\n  color: red;\n  /* Red color for 'Booking Failed' text */\n}\n\n.Booking-cancel-label {\n  font-size: 20px !important;\n  font-weight: bold;\n  color: #002fff;\n  /* Default color for active label */\n  cursor: pointer;\n  /* Pointer cursor when active */\n}\n\n.csv-link {\n  font-weight: bold !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
